import enDashboard from './en/en_dashboard'
import idDashboard from './id/id_dashboard'
import enTracking from './en/en_tracking'
import idTracking from './id/id_tracking'
import enOngkir from './en/en_ongkir'
import idOngkir from './id/id_ongkir'
import enOrder from './en/en_order'
import idOrder from './id/id_order'
import enAdmin from './en/en_admin'
import idAdmin from './id/id_admin'
import enReport from './en/en_report'
import idReport from './id/id_report'
import enTable from './en/en_table'
import idTable from './id/id_table'
import enAddress from './en/en_address'
import idAddress from './id/id_address'
import enVoucher from './en/en_voucher'
import idVoucher from './id/id_voucher'

export default {
  en: {
    // Page
    dashboard: enDashboard,
    tracking: enTracking,
    ongkir: enOngkir,
    order: enOrder,
    admin: enAdmin,
    report: enReport,
    address: enAddress,
    voucher: enVoucher,

    // Component
    table: enTable
  },
  id: {
    // Page
    dashboard: idDashboard,
    tracking: idTracking,
    ongkir: idOngkir,
    order: idOrder,
    admin: idAdmin,
    report: idReport,
    address: idAddress,
    voucher: idVoucher,

    // Component
    table: idTable
  }
}
